
import React from "react";

export default function Logs() {

  return (
    <div>
      ProductLogs.js
    </div>
  );
}



